/*global plupload*/
define('lib/Podio.FileUploader',['require','translate','underscore','jquery','plupload/src/javascript/plupload','plupload/src/javascript/plupload.html5','lib/Podio.Utils','lib/Podio.Config','lib/Podio.Transport','lib/Podio.Routes','signals'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('plupload/src/javascript/plupload');
  require('plupload/src/javascript/plupload.html5');

  var podioUtils = require('lib/Podio.Utils');
  var podioConfig = require('lib/Podio.Config');
  var podioTransport = require('lib/Podio.Transport');
  var podioRoutes = require('lib/Podio.Routes');
  var signalsLib = require('signals');

  $.event.props.push('dataTransfer');
  $.event.props.push('clientX');
  $.event.props.push('clientY');

  var defaultOptions = {
    multipleFiles: true,
    onlyAllowImages: false,
    onlyAllowVideos: false,
    classes : {
      dropzone : 'dropzone',
      button : 'uploader-button'
    }
  };

  var PodioUploader = function(elmTarget, options) {

    options = options ? _.defaults(options, defaultOptions) : defaultOptions;

    var plUploader;
    var elmDropZone;
    var elmUploadButton;
    var elmBody;

    this.features = {};
    this.runtime = '';
    this.signals = {
      onInit            : new signalsLib.Signal(),
      onPostInit        : new signalsLib.Signal(),
      onUploadFinished  : new signalsLib.Signal(),
      onUploadStarted   : new signalsLib.Signal(),
      onUploadProgress  : new signalsLib.Signal(),
      onFileUploaded    : new signalsLib.Signal(),
      onBeforeFileAdded : new signalsLib.Signal(),
      onFileAdded       : new signalsLib.Signal(),
      onFileRemoved     : new signalsLib.Signal(),
      onError           : new signalsLib.Signal(),
      onDocDragEnter    : new signalsLib.Signal(),
      onDocDragLeave    : new signalsLib.Signal(),
      onDocDragEnd      : new signalsLib.Signal(),
      onDragLeave       : new signalsLib.Signal(),
      onDragEnter       : new signalsLib.Signal(),
      onDragOver        : new signalsLib.Signal(),
      onDragEnd         : new signalsLib.Signal()
    };

    function uid() {
      return Math.floor( Math.random()*99999 );
    }

    function isDraggedFileValid(dataTransfer, effect){
      // dataTransfer.effectAllowed (here passed as `effect` due to en IE bug) is none in Safari 5
      // dataTransfer.types.contains check is for firefox

      return dataTransfer && effect != 'none' && (dataTransfer.files || (dataTransfer.types.contains && dataTransfer.types.contains('Files')));
    }

    function upload_url(token) {
      return podioUtils.addQueryString(podioConfig.uploadURL, 'file_upload_token', token);
    }

    function init() {
      var that = this;
      elmUploadButton = elmTarget.find('.' + options.classes.button);
      elmBody = $(document);

      // Assign unique id's to elements
      elmTarget.attr('id', uid() );
      elmUploadButton.attr('id', uid() + 'upload_button');


      var dropZoneId = uid() + 'dropzone';

      var plUploadSettings = {
        runtimes : 'html5',
        url : upload_url(podioConfig.file_upload_token),
        max_file_size : '100mb',
        container : elmTarget.attr('id'),
        browse_button :  elmUploadButton.attr('id'),
        drop_element : dropZoneId,
        unique_names : false,
        multi_selection : options.multipleFiles
      };

      if (options.onlyAllowImages) {
        plUploadSettings.filters = [
          { title : t("Image files  #uploader") , extensions : "jpg,jpeg,gif,png" }
        ];
      } else if (options.onlyAllowVideos) {
        plUploadSettings.filters = [
          { title : t("Video files  #uploader") , extensions : "flv,mov,wmv,3gp,mp4,avi" }
        ];
      }

      if(options.fileFilter) {
        plUploadSettings.filters = options.fileFilter;
      }

      plUploader = new window.plupload.Uploader(plUploadSettings);

      plUploader.bind('QueueChanged', function(uploader) {
        if (uploader.files.length > 0 && plUploader.state != 2) {
          // Just about to start a new upload - this is where we should fetch new
          // file_upload_token since the old one may have expired.

          var p = podioTransport.postJSON(podioRoutes.refresh_file_upload_token_path(), {});
          // ignore failure - the existing token may be fine
          p.success(function(result) {
            if (result.data.file_upload_token) {
              plUploader.settings.url = upload_url(result.data.file_upload_token);
            }
          });

          p.then(function() {
            plUploader.start();
          });
        }
      });

      plUploader.bind('FileUploaded', function(uploader, file, response) {
        if (!response.response) {
          return false;
        }

        var responseData = JSON.parse(response.response);
        var pFile = new PodioUploader.File(file);
        pFile.fileId = responseData.result.file_id;
        _.extend(pFile, responseData.result);

        that.signals.onFileUploaded.dispatch(pFile);
      });

      plUploader.bind('FilesAdded', function(uploader, files) {

        _.each(files, function(file) {
          var pFile = new PodioUploader.File(file);
          that.signals.onBeforeFileAdded.dispatch(pFile);
          that.signals.onFileAdded.dispatch(pFile);
        });

      });

      plUploader.bind('UploadComplete', function(uploader, files) {
        that.signals.onUploadFinished.dispatch(files);
      });

      plUploader.bind('UploadProgress', function(uploader, file) {
        that.signals.onUploadProgress.dispatch(file);
      });


      plUploader.bind('StateChanged', function(uploader) {
        if (uploader.state == window.plupload.STARTED) {
          that.signals.onUploadStarted.dispatch(uploader);
        }
      });

      plUploader.bind('Error', function(uploader, error) {
        that.signals.onError.dispatch(error);
      });

      plUploader.bind('Init', function(uploader) {
        that.signals.onInit.dispatch(uploader);
      });

      plUploader.bind('PostInit', function(uploader) {
        that.features = plUploader.features; // Read features from PLUpload
        that.runtime = plUploader.runtime; // Read runtime from PLUpload

        initDragDrop.call(that, dropZoneId);

        that.signals.onPostInit.dispatch();
      });

      plUploader.init();

    }

    function initDragDrop(dropZoneId) {

      var that = this;

      // For calculating cancelled drags.
      // See http://stackoverflow.com/questions/11341277/detecting-a-cancelled-drag-and-drop-action-when-uploading-files
      // for details on the "interesting" implementation of HTML5 drag/drop
      var counter = 0;

      elmDropZone = elmTarget.find('.' + options.classes.dropzone);

      // Drag and drop events
      if (!elmDropZone.length) {
        return; // Dropzone not there - abort
      }

      if(!isDragDropSupported()) {
        return; // Not supported - get out
      }

      elmDropZone.attr('id', dropZoneId);

      elmDropZone.on('dragenter', function() {
        that.signals.onDragEnter.dispatch(elmDropZone);
      });

      elmDropZone.on('dragleave', function() {
        that.signals.onDragLeave.dispatch(elmDropZone);
      });

      elmDropZone.on('dragend drop', function() {
        that.signals.onDragEnd.dispatch(elmDropZone);
      });

      elmBody.on('dragend drop', function() {
        that.signals.onDocDragEnd.dispatch(elmDropZone);
      });

      elmBody.on('dragenter', function() {
        counter++;
       that.signals.onDocDragEnter.dispatch(elmDropZone);
      });

      elmDropZone.on('dragover', function(e) {
        if (e.dataTransfer) {

          // IE10 and IE 11 has a bug where you can't access effectAllowed without getting an exception.
          // We swallow this exception. More details: https://github.com/enyo/dropzone/issues/441
          var effect;
          try {
            effect = e.dataTransfer.effectAllowed;
          } catch (_error) {}

          if(!isDraggedFileValid(e.dataTransfer, effect)) {
            return;
          }

          if (effect == 'move' || effect == 'linkMove') {
            e.dataTransfer.dropEffect = 'move'; // for FF (only move allowed)
          } else {
            e.dataTransfer.dropEffect = 'copy'; // for Chrome
          }
        }

        that.signals.onDragOver.dispatch(elmDropZone);
        return false;
      });

      elmBody.on('dragover', function(e) {
        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = 'none';
          e.preventDefault();
        }
      });

      elmBody.on('dragleave', function(e) {
        counter--;

        var relatedTarget = e.relatedTarget || document.elementFromPoint(e.clientX, e.clientY);
        // only fire when leaving document out

        if (!relatedTarget) {
          that.signals.onDocDragLeave.dispatch(elmDropZone);
        }

        // Cancelled drop
        if (counter === 0) {
          that.signals.onDocDragEnd.dispatch(elmDropZone);
        }
      });

    }

    function dispose() {

      // Clean up signals
      _.each(this.signals, function(signal) {
        signal.removeAll();
      });

      // Clean up DOM event bindings
      if(isDragDropSupported()) {
        elmDropZone.off('dragenter dragleave dragover dragend drop');
        elmBody.off('dragenter dragleave');
      }

      if(plUploader) {
        // Clean up PlUpload event bindings
        plUploader.unbindAll();

        // Destroy plUpload object
        plUploader.destroy();
      }

    }

    function refresh() {
      plUploader.refresh();
    }

    function showDialog() {
      if(isFlashUploader()) {
        return;
      }

      var elmUploaderButton = $('#' + plUploader.id + '_' + plUploader.runtime);
          elmUploaderButton.click();
    }

    function isFlashUploader() {
      return plUploader && plUploader.runtime === 'flash';
    }

    function isDragDropSupported() {
      return plUploader && plUploader.features.dragdrop === true;
    }

    return {
      init: init,
      dispose: dispose,
      refresh: refresh,
      isFlashUploader : isFlashUploader,
      isDragDropSupported: isDragDropSupported,
      showDialog: showDialog,
      signals : this.signals,
      features : this.features,
      runtime : this.runtime
    };

  };

  PodioUploader.File = function(pluploadFile) {
    var self = this; // Setup alias for self to reduce code size when it's compressed

    self.id = null;
    self.fileId = null;
    self.mimeType = null;
    self.icon = null;
    self.name = name;
    self.size = 0;
    self.isImage = false;

    if (pluploadFile) {
      self = _.extend(self, pluploadFile);
      self.mimeType = plupload.mimeTypes[self.name.replace(/^.+\.([^.]+)/, '$1').toLowerCase()] || 'application/octet-stream';
      self.isImage = self.mimeType.indexOf('image') > -1 && (!/tiff|tif|x-tiff|x-tif/.test(self.mimeType));
    }

  };

  PodioUploader.File.prototype.createFromPodioFile = function(podioFile) {
    var self = this;

    self.id = podioFile.file_id;
    self.fileId = podioFile.file_id;
    self.name = podioFile.name;
    self.size = podioFile.size;
    self.icon = podioFile.icon;
    self.mimeType = podioFile.mimetype;

    self.isImage = self.mimeType.indexOf('image') > -1 && (!/tiff|tif|x-tiff|x-tif/.test(self.mimeType));

    self.podioFile = podioFile;

    return self;
  };


  return PodioUploader;

});

